import { render, staticRenderFns } from "./FormComponentDemoPage.vue?vue&type=template&id=5c1bbf12&scoped=true&"
import script from "./FormComponentDemoPage.vue?vue&type=script&lang=ts&"
export * from "./FormComponentDemoPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1bbf12",
  null
  
)

export default component.exports